/* eslint-disable camelcase */
import {
    SAVE_SURGERY_DETAILS_SUCCESS,
    SAVE_SURGERY_DETAILS_FAILURE,
    SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
} from '../actions';

import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { removeEmptyFieldsFromObject } from 'src/utils/util';

export default function* saveSurgery(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/order/surgery`;
    const payload = removeEmptyFieldsFromObject(action.payload);

    try {
        const result = yield axios
            .post(url, payload)
            .then((response) => response.data);
        if (result.myCaseRef) {
            const modify_result = {
                ...result,
                isSubmitted: action.payload.isSubmitted,
            };
            yield put({
                type: SAVE_SURGERY_DETAILS_SUCCESS,
                data: modify_result,
            });
            yield put({
                type: SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
                data: false,
            });
        } else {
            yield put({
                type: SAVE_SURGERY_DETAILS_FAILURE,
                data: {
                    message: errorHandler('999'),
                    statusCode: '999',
                },
            });
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: payload
        });
        yield put({
            type: SAVE_SURGERY_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
